import React from 'react';

import BusinessReviewModal from './BusinessReviewModal';
import {
  getDemoBusinessReviewPresentation,
  getDemoBusinessReviewProps,
} from '../utils/businessReviewDemoProps';

/**
 * Single entry point for BusinessReviewModal on every public landing page and demo.
 * Wraps the shared modal with consistent demo data and presentation presets so
 * updates to BusinessReviewModal propagate everywhere automatically.
 *
 * presentation:
 *   - "map"       — full overlay (ConsumerLanding / MarketReport map), sized
 *                   identically to the in-app modal so it reads well on mobile
 *   - "hero"      — inline card (AgencyLanding hero carousel)
 *   - "embed"     — flush iframe embed (agencies landing page)
 *   - "dashboard" — full overlay (dashboard showcase demos)
 *
 * dataVariant:
 *   - "default"              — Nashville junk removal demo dataset
 *   - "where-they-are"       — agency hero weak-rank storytelling slide
 *   - "where-youll-take-them" — agency hero strong-rank storytelling slide
 */
const DemoBusinessReviewModal = ({
  isOpen,
  onClose,
  business,
  presentation = 'dashboard',
  dataVariant = 'default',
  ...rest
}) => {
  const demoProps = getDemoBusinessReviewProps(dataVariant);
  const presentationProps = getDemoBusinessReviewPresentation(presentation);
  const { business: presetBusiness, ...sharedDemoProps } = demoProps;

  return (
    <BusinessReviewModal
      isOpen={isOpen}
      onClose={onClose}
      business={business || presetBusiness}
      {...sharedDemoProps}
      {...presentationProps}
      {...rest}
    />
  );
};

export default DemoBusinessReviewModal;
